var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h2',[_vm._v("See it in action.")]),_c('a',{attrs:{"href":_vm.authUrl}},[_vm._v("Log in with Spotify")])])}
var staticRenderFns = []

export { render, staticRenderFns }